import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';

export const generateReport = (
  token,
  cid,
  lid,
  type,
  summary,
  fromDate,
  toDate,
  selectedReport,
  symbol,
  lineTypes,
  alarmProtocolValue,
  integration,
) => async dispatch => {
  console.log('selectedReport_______', selectedReport, symbol);
  const api = new Api(token);
  dispatch({
    type: 'GENERATE_REPORT',
  });
  try {
    const activationReport = await api.reports.generateReport({
      cid,
      lid,
      type,
      summary,
      fromDate,
      toDate,
      selectedReport,
      symbol,
      lineTypes,
      alarmProtocolValue,
      integration,
    });
    dispatch({
      type: 'GENERATE_REPORT_SUCCESS',
      activationReport,
    });
  } catch (error) {
    dispatch({
      type: 'GENERATE_REPORT_ERROR',
      error,
    });
    // const reader = new FileReader();
    // reader.onload = function() {
    toast.error(error?.response?.data || ERROR_MESSAGE);
    // };
    // reader.readAsText(error.response.data);
  }
};

export const getCompanyGroups = (token, pagination, format) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'COMPANY_GROUP_LIST',
  });
  try {
    const companyGroupList = await api.reports.getCompanyGroups(pagination, format);
    dispatch({
      type: 'COMPANY_GROUP_LIST_SUCCESS',
      companyGroupList,
    });
    return companyGroupList;
  } catch (error) {
                    dispatch({
                      type: 'COMPANY_GROUP_LIST_ERROR',
                      error,
                    });
                    // const reader = new FileReader();
                    // reader.onload = function() {
                    toast.error(error?.response?.data || ERROR_MESSAGE);
                    // };
                    // reader.readAsText(error.response.data);
                  }
};
export const getGroupsFilterCompanies = (token, gid) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GROUP_FILTER_COMPANIES',
  });
  try {
    const getGroupsFilterCompanies = await api.reports.getGroupsFilterCompanies(gid);
    dispatch({
      type: 'GROUP_FILTER_COMPANIES_SUCCESS',
      getGroupsFilterCompanies,
    });
    return getGroupsFilterCompanies;
  } catch (error) {
    dispatch({
      type: 'GROUP_FILTER_COMPANIES_ERROR',
      error,
    });
    // const reader = new FileReader();
    // reader.onload = function() {
    toast.error(error?.response?.data || ERROR_MESSAGE);
    // };
    // reader.readAsText(error.response.data);
  }
};
